import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById('lead-form').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav 
      className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-mission-green shadow-xl py-3' : 'bg-transparent py-5'}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">
        <div 
          className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 cursor-pointer" 
          onClick={() => window.scrollTo(0, 0)}
        >
          <span className="font-serif text-xl md:text-2xl tracking-[0.2em] text-spanish-ivory">
            PADUA WEDDINGS
          </span>
          <div className="h-6 w-px bg-antique-gold/40 hidden sm:block"></div>
          <span className="font-sans text-[9px] md:text-[10px] tracking-[0.3em] uppercase text-antique-gold font-semibold">
            Corporate Events
          </span>
        </div>

        <button 
          onClick={scrollToForm}
          className={`px-6 py-2.5 rounded text-xs tracking-widest uppercase font-semibold transition-all duration-300 ${
            scrolled 
            ? 'bg-antique-gold text-mission-dark hover:bg-spanish-ivory hover:text-mission-green' 
            : 'bg-spanish-ivory text-mission-green hover:bg-antique-gold hover:text-mission-dark'
          }`}
        >
          Check Availability
        </button>
      </div>
    </motion.nav>
  );
};

export default Navbar;